import { getCompanyDetailsByUrl } from '@api/company';
import CheckYourInbox from '@components/Templates/CheckYourInbox';
import { sanitizeLoginEmailParam } from '@helpers/auth.helper';
import AuthenticationLayout from '@layouts/AuthenticationLayout';
import { LoadingBackdrop } from '@shared/molecules';
import { PublicCompanyDetails, castResponse } from 'custom.d';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';

const LoginPage: React.FunctionComponent = () => {
  const { companyURL, email: emailParam } = useParams<UrlParamsType>();
  const email = sanitizeLoginEmailParam(emailParam);
  const [companyDetails, setCompanyDetails] = useState<PublicCompanyDetails | null>(null);
  const [isCompanyConfigLoading, setIsCompanyConfigLoading] = useState(() => Boolean(companyURL));
  let organizationLogo: string | undefined;
  let organizationAltText: string | undefined;
  let hideHapstarLogo = false;
  let platformName: string | null = null;
  let organizationId = 0;

  useEffect(() => {
    if (!companyURL) {
      setCompanyDetails(null);
      setIsCompanyConfigLoading(false);

      return undefined;
    }

    let cancelled = false;
    setIsCompanyConfigLoading(true);

    const getCompanyData = async () => {
      try {
        const response = await getCompanyDetailsByUrl(companyURL);
        if (cancelled) {
          return;
        }

        if (response?.success) {
          const data = castResponse<PublicCompanyDetails>(response);
          setCompanyDetails(data);
        } else {
          setCompanyDetails(null);
        }
      } catch {
        if (!cancelled) {
          setCompanyDetails(null);
        }
      } finally {
        if (!cancelled) {
          setIsCompanyConfigLoading(false);
        }
      }
    };

    getCompanyData();

    return () => {
      cancelled = true;
    };
  }, [companyURL]);

  if (isCompanyConfigLoading) {
    return (
      <AuthenticationLayout title="CheckYourInbox">
        <LoadingBackdrop text="Loading..." />
      </AuthenticationLayout>
    );
  }

  if (companyDetails !== null) {
    organizationLogo = companyDetails.companyLogo
      ? `${process.env.PUBLIC_URL}/images/logos/${companyDetails.companyLogo}`
      : undefined;
    organizationAltText = `${companyDetails.companyName} logo`;
    hideHapstarLogo = companyDetails.hideHapstarLogo;
    platformName =
      companyDetails.platformName &&
      companyDetails.platformName !== 'null' &&
      companyDetails.platformName !== null
        ? companyDetails.platformName
        : null;
    organizationId = companyDetails?.id || 0;
  }

  return (
    <CheckYourInbox
      organizationLogo={organizationLogo}
      organizationAltText={organizationAltText}
      companyURL={companyURL}
      email={email}
      hideHapstarLogo={hideHapstarLogo}
      platformName={platformName}
      organizationId={organizationId}
    />
  );
};

type UrlParamsType = {
  email: string;
  companyURL: string;
};

export default LoginPage;
